// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settlementId: __t.u64().primaryKey().name("settlement_id"),
  worldId: __t.u64().name("world_id"),
  centerX: __t.f32().name("center_x"),
  centerZ: __t.f32().name("center_z"),
  stockFood: __t.u32().name("stock_food"),
  stockOre: __t.u32().name("stock_ore"),
  stockTools: __t.u32().name("stock_tools"),
  stockLuxury: __t.u32().name("stock_luxury"),
  priceFood: __t.u32().name("price_food"),
  priceOre: __t.u32().name("price_ore"),
  priceTools: __t.u32().name("price_tools"),
  priceLuxury: __t.u32().name("price_luxury"),
  treasury: __t.i64(),
  taxBps: __t.u32().name("tax_bps"),
  mayorId: __t.u64().name("mayor_id"),
  nextElectionAt: __t.timestamp().name("next_election_at"),
  projectKey: __t.string().name("project_key"),
  projectProgress: __t.u32().name("project_progress"),
  projectTarget: __t.u32().name("project_target"),
  updatedAt: __t.timestamp().name("updated_at"),
});
